var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('require-fetch-template',[(_vm.playerResults)?_c('div',[_c('results',{attrs:{"results-with-pagination":_vm.playerResults,"paginator":_vm.paginator}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }